import { Box } from "@chakra-ui/react";
import NewTable from "components/NewTable";
import HeaderTable from "components/Page/HeaderTable";
import useListarContasParaExtrato from "core/features/conciliacao-bancaria/hooks/useListaContasParaExtrato";
import { useMemo, useState } from "react";
import useContaTableColumns from "../hooks/useContaTableColumns";
import { MdCheck } from "react-icons/md";
import { useEstornarConta } from "features/conta/hooks";
import { showErrorAxios, showConfirm2 } from "infra/helpers/alerta";
import { useLoading } from "components/GlobalLoading";

interface ModalConciliarProps {
  data: string;
  contasBancariasIds?: string[];
  onLiquidacaoCancelada?: () => any;
}

export default function ListaContas({
  data,
  contasBancariasIds,
  onLiquidacaoCancelada,
}: ModalConciliarProps) {
  const [search, setSearch] = useState<string | undefined>(undefined);

  const {
    isLoading: isLoadingContas,
    isFetching: isFetchingContas,
    data: contas,
    refetch,
  } = useListarContasParaExtrato(
    {
      dataInicio: data,
      dataFim: data,
      extratosBancariosIds: undefined,
      search,
      naoConciliado: "1",
      incluirTransferencias: "1",
      contasBancariasIds,
    },
    true
  );

  const { mutate: estornarConta, isLoading: isLoadingEstornarConta } =
    useEstornarConta();

  const onEstornarConta = async (id: string) => {
    estornarConta(id, {
      onSuccess: () => {
        refetch();
        onLiquidacaoCancelada?.();
      },
      onError: (err: unknown) => showErrorAxios(err),
    });
  };

  const columns = useContaTableColumns();

  const items = useMemo(() => {
    return contas?.items || [];
  }, [contas?.items]);

  useLoading(isLoadingEstornarConta);

  return (
    <>
      <Box mt="16px" px="8px" id="lista-contas-conciliacao">
        <NewTable
          loading={isLoadingContas || isFetchingContas}
          dataSource={items ?? []}
          columns={columns}
          actions={[
            {
              title: (v) => "Cancelar Liquidação",
              icon: () => <MdCheck />,
              onClick: (v) => {
                showConfirm2({
                  message: "Deseja realmente estornar esta conta?",
                  onOk: () => onEstornarConta?.(v.id),
                });
              },
            },
          ]}
          title={() => (
            <HeaderTable
              value={search ?? ""}
              onSearch={(q?: string) => setSearch(q)}
            />
          )}
        />
      </Box>
    </>
  );
}
